import {logHandledError} from '../../services/errors/errorReporting';
import {recordRumDurationVital} from '../datadog/datadogRum';
import {fnv1a64} from './fnv';

export function getCacheStorageKey(namespace: string, key: any): string | null {
  if (key == null) {
    return null;
  }
  const stringified = JSON.stringify(key);

  const hash = fnv1a64(`${namespace}--${stringified}`);

  return `${hash}.json`;
}
export async function logPerfAndErrors<T>(
  operationName: string,
  fn: () => Promise<T>,
  namespace: string,
  context?: Record<string, any>
): Promise<T | void> {
  const startMark = performance.now();
  try {
    const result = await fn();
    return result;
  } catch (err: any) {
    if (context) {
      context.outcome = 'error';
    }
    const errMsg = `[${namespace}: ${operationName}] Error - ${err}`;
    logHandledError(errMsg);
    console.error(errMsg);
  } finally {
    recordRumDurationVital('workspace.func_perf.logPerfAndErrors', {
      startTime: performance.timeOrigin + startMark,
      duration: performance.now() - startMark,
      description: `${namespace} ${operationName} duration`,
      context: {
        ...context,
        operationName,
        namespace,
      },
    });
  }
}
